function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calculator"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m19 2h-14c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-14c0-1.654-1.346-3-3-3zm1 17c0 .552-.449 1-1 1h-14c-.551 0-1-.448-1-1v-14c0-.552.449-1 1-1h14c.551 0 1 .448 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11 8h-1v-1c0-.553-.448-1-1-1s-1 .447-1 1v1h-1c-.552 0-1 .447-1 1s.448 1 1 1h1v1c0 .553.448 1 1 1s1-.447 1-1v-1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11 14.5h-4c-.552 0-1 .447-1 1s.448 1 1 1h4c.552 0 1-.447 1-1s-.448-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 16h-3c-.552 0-1 .447-1 1s.448 1 1 1h3c.552 0 1-.447 1-1s-.448-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 13h-3c-.552 0-1 .447-1 1s.448 1 1 1h3c.552 0 1-.447 1-1s-.448-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.707 6.793c-.391-.391-1.023-.391-1.414 0l-.793.793-.793-.793c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l.793.793-.793.793c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l.793-.793.793.793c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-.793-.793.793-.793c.391-.391.391-1.023 0-1.414z"
})));

var Svg022Calculator = function Svg022Calculator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg022Calculator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/022-calculator.8f590a25.svg";
export { ForwardRef as ReactComponent };